import {
  SET_SECTOR_UI_FLAG,
  CLEAR_SECTORS,
  SET_SECTORS,
  SET_SECTOR_ITEM,
  EDIT_SECTOR,
  DELETE_SECTOR,
  SET_ACTIVE_SECTOR,
  SET_ALL_SECTORS,
} from './types';

export const mutations = {
  [SET_SECTOR_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },

  [CLEAR_SECTORS]: $state => {
    $state.records = {};
  },

  [SET_SECTORS]: ($state, data) => {
    const updatedRecords = { ...$state.records };
    data.forEach(sector => {
      updatedRecords[sector.id] = {
        ...(updatedRecords[sector.id] || {}),
        ...sector,
      };
    });
    $state.records = updatedRecords;
  },

  [SET_SECTOR_ITEM]: ($state, data) => {
    $state.records = {
      ...$state.records,
      [data.id]: { ...($state.records[data.id] || {}), ...data },
    };
  },

  [EDIT_SECTOR]: ($state, data) => {
    $state.records = { ...$state.records, [data.id]: data };
  },

  [DELETE_SECTOR]: ($state, sectorId) => {
    const { [sectorId]: toDelete, ...records } = $state.records;
    $state.records = records;
  },

  [SET_ACTIVE_SECTOR]: ($state, sectorId) => {
    $state.activeSectorId = sectorId;
  },

  [SET_ALL_SECTORS]: ($state, data) => {
    $state.allSectors = data;
  },
};
